export default __webpack_public_path__ + "static/media/background-features.b36cb214.png";